import { CalendarRange } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import type { ListMyRequests } from '@cold-ambulance/client';
import { Card, CardContent, buttonVariants } from '@cold-ambulance/shadcn';
import { formatDate, LocationLink } from '@cold-ambulance/ui';

export function ActiveServiceCard({
  service,
}: {
  service: ListMyRequests['records'][number];
}) {
  const { t } = useTranslation();
  return (
    <Card className="border-primary bg-[#E9F6ED]">
      <CardContent className="flex flex-col gap-4 py-6">
        <div className="flex items-center gap-2">
          <span className="size-3 animate-pulse rounded-full bg-green-500" />
          <span className="text-sm font-medium text-green-700">{t('home.activeService')}</span>
        </div>
        <h2 className="text-lg font-bold">{service.projectName}</h2>
        <LocationLink
          name={service.location.name}
          latitude={service.location.latitude}
          longitude={service.location.longitude}
          className="text-sm"
        />
        <p className="flex items-center gap-2 text-sm">
          <CalendarRange size={20} />
          {formatDate(service.scheduleStartDate)} -{' '}
          {formatDate(service.scheduleEndDate)}
        </p>
        <Link
          to={`/requests/${service.id}`}
          viewTransition
          className={buttonVariants({
            variant: 'outline',
            className:
              'border-primary text-primary mt-auto !h-11 w-full bg-white px-6 font-bold',
          })}
        >
          {t('common.viewDetails')}
        </Link>
      </CardContent>
    </Card>
  );
}
